"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SenderType;
(function (SenderType) {
    SenderType[SenderType["User"] = 0] = "User";
    SenderType[SenderType["Bot"] = 1] = "Bot";
})(SenderType = exports.SenderType || (exports.SenderType = {}));
var Validity;
(function (Validity) {
    Validity["VALID"] = "valid";
    Validity["INVALID"] = "invalid";
    Validity["UNKNOWN"] = "unknown";
    Validity["WARNING"] = "warning";
})(Validity = exports.Validity || (exports.Validity = {}));
//# sourceMappingURL=TrainDialog.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@conversationlearner/models/dist/TrainDialog.js
// module id = 332
// module chunks = 0